<script context="module" lang="ts">
	import EventSummary from '$lib/components/events/EventSummary.svelte';
	import Wrapper from '$lib/components/utils/ResponsiveWrapper.svelte';
	import MetaTags from '$lib/components/utils/MetaTags.svelte';

	import Event from '$lib/components/events/Event.svelte';
	import Spinner from '$lib/components/Spinner.svelte';
	import icoAdd from 'iconoir/icons/plus-circle.svg';

	import getPermissions from '$lib/components/auth/getPermissions';

	async function canCreate() {
		return await getPermissions('create-event');
	}
</script>

<script lang="ts">
	/** @type {import('./$types').PageData} */
	export let data;

	const events = data.events;
</script>

<MetaTags
	title="Events"
	desc="Find out the latest thing happening at Active. Your comps, gatherings and more are all here!"
/>

<Wrapper title="Events">
	<div class="pt-8" />
	{#await canCreate()}
		<div />
	{:then result}
		{#if result === true}
			<div class="mb-4 w-fit rounded-full bg-zinc-900 px-4 py-1">
				<a href="/events/create/">
					<p class="inline-block text-white">Add Event</p>
					<img
						class="inline-block w-6"
						src={icoAdd}
						alt="Add Event"
						style="filter: invert(94%) sepia(25%) saturate(0%) hue-rotate(354deg) brightness(103%) contrast(102%);"
					/>
				</a>
			</div>
		{/if}
	{/await}

	<div class="grid grid-cols-1 gap-4 md:grid-cols-2">
		{#if events.length === 0}
			<div class="rounded-md bg-white p-2 pb-4 drop-shadow-sm col-span-full">
				<p class="text-center text-lg font-medium">No Events Currently!</p>
				<p class="pt-4 text-center">Check back later to see our latest events, comps & more :)</p>
			</div>
		{/if}
		{#each events as event}
			<Event
				id={event._id}
				eventName={event.eventName}
				eventDesc={event.eventDesc}
				eventStartDateTime={event.eventStartDateTime}
				eventEndDateTime={event.eventEndDateTime}
				eventCost={event.eventCost}
				eventLocation={event.eventLocation}
				eventImage={event.eventImage}
				eventImageFocal={event.eventImageFocal}
				eventCategory={event.eventCategory}
			/>
		{/each}
	</div>
</Wrapper>
